/**
 * @fileoverview This file provides a function to fetch and convert the content of a URL to markdown. It utilizes the `urlToMarkdown` utility from the shared-node package.
 */

import { urlToMarkdown } from '@iterator/shared-node/util/url_to_markdown'

/**
 * Get the markdown content of a URL
 *
 * @param url - The URL to convert to markdown
 * @returns The markdown content of the URL
 */
export async function getMarkdownFromUrl(url: string) {
  // TODO: store files in the awolf directory and cache files locally.
  return urlToMarkdown(url)
}
